import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { PUT_NON_NATIONAL_APPLICATION_STATUS } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';

// =============================================================================
// Request & Response Model
// =============================================================================

export interface PutNonNationalExamApplicationStatusResponse {}

export interface PutNonNationalExamApplicationStatusRequest {
  status: string;
  candidateRemark: string;
  internalRemark: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PutNonNationalExamApplicationStatusResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  onSettled?: () => void;
  uuid: string;
}

export const usePutNonNationalExamApplicationStatus = ({
  onSuccess,
  onError,
  onSettled,
  uuid,
}: Input) => {
  const putNonNationalExamApplicationStatus = async (
    payload: PutNonNationalExamApplicationStatusRequest
  ) => {
    const res = await axiosClient.put<PutNonNationalExamApplicationStatusResponse>(
      PUT_NON_NATIONAL_APPLICATION_STATUS(uuid),
      payload
    );
    return res.data;
  };

  return useCustomMutation(putNonNationalExamApplicationStatus, {
    onSuccess,
    onError,
    onSettled,
  });
};
